import React from 'react';

export function UserTableSortTh({ sortKey, label, sortConfig, onSort, className = '' }) {
  const isActive = sortConfig.key === sortKey;
  const directionLabel = isActive
    ? sortConfig.direction === 'asc'
      ? 'crescente'
      : 'decrescente'
    : 'nenhuma';
  const ariaSort = isActive
    ? sortConfig.direction === 'asc'
      ? 'ascending'
      : 'descending'
    : 'none';

  return (
    <button
      type="button"
      className={`um-detail-th${isActive ? ' is-sorted' : ''}${className ? ` ${className}` : ''}`}
      onClick={() => onSort(sortKey)}
      aria-label={`Ordenar por ${label} (${directionLabel})`}
      aria-sort={ariaSort}
    >
      <span>{label}</span>
      {isActive ? (
        <span className="um-detail-th-dir" aria-hidden>
          {sortConfig.direction === 'asc' ? '↑' : '↓'}
        </span>
      ) : null}
    </button>
  );
}
